<template>
	<div>
		<Layout>
			<div class="container mt-3">
				<div class="row row-xs d-flex">
					<div class="col-12 mt-4 mb-4">
						<h1>Mi cuenta</h1>
					</div>
				</div>
				<div class="row row-xs d-flex no-wrap">
					<AccountSidebar tab="events" />

					<div class="page" v-if="eventPromoted">
						<div class="card mb-3">
							<div class="card-body">
								<EventCard :eventId="eventPromoted.event.id" />

								<div class="mt-3">
									<ShareLink
										:link="eventPromoted.publicLink"
										:title="`Comprá tu entrada para el evento ${eventPromoted.event.name}`"
									/>
								</div>
							</div>
						</div>

						<div v-if="eventPromoted.event.status == 'ACTIVE'">
							<CourtesyTicketsInvite
								:userId="promotorId"
								:eventId="eventPromoted.event.id"
								@updated="load()"
								v-if="!loading"
							/>
						</div>

						<div class="card mb-3">
							<div class="card-body">
								<h5>Tickets</h5>
								<TicketList
									:promotorId="promotorId"
									:eventId="eventPromoted.event.id"
									:hideEventColumn="true"
									:allowSelection="true"
									v-if="!loading"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Layout>
	</div>
</template>

<script>
import gql from "graphql-tag"
import Layout from "@/components/Layout"
import ShareLink from "@/components/ShareLink"
import AccountSidebar from "./AccountSidebar"
import EventCard from "@/views/events/EventCard"
import TicketList from "./TicketList"
import CourtesyTicketsInvite from "./CourtesyTicketsInvite"

export default {
	name: "PromoteEvent",
	components: {
		Layout,
		ShareLink,
		AccountSidebar,
		EventCard,
		TicketList,
		CourtesyTicketsInvite
	},
	data() {
		return {
			eventPromoted: null,
			loading: true,
			promotorId: null
		}
	},
	beforeMount() {
		this.promotorId = this.$store.getters.loggedUser.id
		this.load()
	},
	methods: {
		load() {
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							eventPromoted(id: $id) {
								id
								publicLink
								ticketsSold
								event {
									id
									name
									startAt
									image {
										id
										url
										urlThumb
									}
									status
								}
							}
						}
					`,
					variables: {
						id: this.$route.params.id
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.eventPromoted = data.eventPromoted
					this.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.page {
	flex-grow: 1;
	flex-shrink: 1;
}
.no-wrap {
	flex-wrap: nowrap;
}
</style>
